import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=045d57d7&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=ts"
export * from "./Tables.vue?vue&type=script&lang=ts"
import style0 from "./Tables.vue?vue&type=style&index=0&id=045d57d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d57d7",
  null
  
)

export default component.exports